export default "__VITE_ASSET__Blh5EBlt__"